import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { JsonEditorComponent, JsonEditorOptions } from 'ang-jsoneditor';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { activityPackStastics } from 'src/app/Modules/idms/components/project-manager/models/projectDetails.model';
import { UniqueNameValidation } from 'src/app/Modules/management/core/Validators/unique-name.validator';
import { ModalTransaction } from 'src/app/Modules/management/enums/organization-transction.enum';
import {
    ActivityPackType,
    ActivityPackTypeStatus,
    ActivityPackTypeStatusType,
    ActivityStatusType,
    ActivityWorkFlowHierarchy,
    Activitypacktypestatusfunctions,
} from 'src/app/Modules/management/models/instance/activity-pacck-type.model';
import { SchemaRevision, SchemaVersion } from 'src/app/Modules/management/models/instance/project-type.model';
import { ManagementApiService } from 'src/app/services';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { InstanceDataService } from 'src/app/services/instance-data.service';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { CustomValidatorService } from 'src/app/services/custom-validator.service';
@Component({
    selector: 'app-create-view-workflow-status',
    templateUrl: './create-view-workflow-status.component.html',
    styleUrls: ['./create-view-workflow-status.component.scss'],
})
export class CreateViewWorkflowStatusComponent implements OnInit, OnDestroy {
    @Input() workFlowStatus: ActivityWorkFlowHierarchy;
    @Input() activityPackName: string;
    @Input() currentActivityPack: ActivityPackType;
    @Input() modalMode: number;
    @Input() indexOfStatus: number;
    @Input() currentWorkflowSteps: ActivityWorkFlowHierarchy[];
    @Input() workflowStatusTypes: ActivityStatusType[];
    @Input() activitypacktypestatusfunctionsList: Activitypacktypestatusfunctions;
    @ViewChild('editor') editor: JsonEditorComponent;
    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

    header_instanceName: string;
    header_assetType: string;
    header_activityPackType: string;
    pageSize: number;
    currentPageItemLength: number;
    editorOptions: JsonEditorOptions;
    schemaVersionList: SchemaVersion[];
    fullSchemaVersionList: SchemaVersion[];
    updatedSchema: string;
    isSchemaAdd: boolean;
    destroy$ = new Subject();
    workflowStatusForm: UntypedFormGroup;
    payload: ActivityWorkFlowHierarchy[];
    newWorkflowStatus: ActivityWorkFlowHierarchy;
    activityWorkFlowStatus: any[];
    dataSource;
    @ViewChild(MatTable) table: MatTable<any>;
    tooltip_position = 'above';
    displayedColumns: string[] = ['statusName', 'color'];
    constructor(
        private instanceDataService: InstanceDataService,
        private cd: ChangeDetectorRef,
        private managementApiService: ManagementApiService,
        private ngxUiLoaderService: NgxUiLoaderService,
        public ngbActiveModal: NgbActiveModal,
        private formBuilder: UntypedFormBuilder,
        private customToastService: CustomToastService,
        private customValidator: CustomValidatorService
    ) {
        this.schemaVersionList = [];
        this.fullSchemaVersionList = [];
        this.pageSize = 4;
        this.isSchemaAdd = false;
        this.payload = [];
        this.newWorkflowStatus = new ActivityWorkFlowHierarchy();
        let newActivityPackTypeStatus = new ActivityPackTypeStatus();
        this.newWorkflowStatus.activityPackTypeStatus = newActivityPackTypeStatus;
        this.activityWorkFlowStatus = [
            {
                name: '',
                colour: '',
            },
        ];
        this.dataSource = new MatTableDataSource<any>(this.activityWorkFlowStatus);
    }

    ngOnInit(): void {
        this.workflowStatusTypes = this.workflowStatusTypes.filter(
            (item) => !(item.name.toLowerCase().trim() == 'archived' || item.name.toLowerCase().trim() == 'cancel')
        );
        if (this.workFlowStatus !== null && this.workFlowStatus.activityPackTypeStatus?.schemaVersions) {
            this.workFlowStatus.activityPackTypeStatus.schemaVersions.forEach((schema) => {
                // this.fullSchemaVersionList.push({
                //     schemaVersionId: schema.schemaVersionId,
                //     version: schema.version,
                //     schema: JSON.parse(schema.schema),
                // });

                try {
                    this.fullSchemaVersionList.push({
                        schemaVersionId: schema.schemaVersionId,
                        version: schema.version,
                        schema: JSON.parse(schema.schema),
                    });
                } catch (error) {
                    console.error('Invalid JSON found in schema:', schema.schema, error);

                    // Option 1: Push a fallback object instead
                    this.fullSchemaVersionList.push({
                        schemaVersionId: schema.schemaVersionId,
                        version: schema.version,
                        schema: null, // or {}
                    });
                }
            });
            this.currentPageItemLength = this.fullSchemaVersionList.length;
            this.schemaVersionList = this.fullSchemaVersionList.slice().reverse().slice(0, this.pageSize);
        }
        this.initializeFormControl();
    }

    // * handler to add the new schema version
    addNewSchemaVersion() {
        this.isSchemaAdd = true;
        this.workflowStatusForm.markAsDirty();
        if (this.workFlowStatus) {
            // TODO while editing the status
            if (this.fullSchemaVersionList.length > 0) {
                this.fullSchemaVersionList.push({
                    version: this.fullSchemaVersionList.length + 1,
                    schema: this.fullSchemaVersionList[this.fullSchemaVersionList.length - 1].schema,
                });
                this.updatedSchema = this.fullSchemaVersionList[this.fullSchemaVersionList.length - 1].schema;
            } else {
                this.fullSchemaVersionList.push({
                    version: this.fullSchemaVersionList.length + 1,
                    schema: '',
                });
                this.updatedSchema = this.fullSchemaVersionList[this.fullSchemaVersionList.length - 1].schema;
            }

            if (this.fullSchemaVersionList.length > 4) {
                this.currentPageItemLength = this.fullSchemaVersionList.length; // * this is important for working pagination
                this.cd.detectChanges();
                this.paginator.firstPage();
            }
            this.schemaVersionList = this.fullSchemaVersionList.slice().reverse().slice(0, this.pageSize);
        } else {
            // TODO while creating new status
            this.fullSchemaVersionList.push({
                schemaVersionId: null,
                version: 1,
                schema: JSON.parse('{}'),
            });
            this.schemaVersionList = this.fullSchemaVersionList.slice().reverse().slice(0, this.pageSize);
            this.updatedSchema = this.fullSchemaVersionList[this.fullSchemaVersionList.length - 1].schema;
        }
    }

    // * helper method to get the schema data
    getSchemaData(schemaVersionId: string) {
        if (schemaVersionId) {
            let schema = this.fullSchemaVersionList.find((schema) => schema.schemaVersionId == schemaVersionId);
            return schema.schema;
        } else {
            return this.fullSchemaVersionList[this.fullSchemaVersionList.length - 1].schema;
        }
    }

    // * helper method to return the custom json-editor options
    getJsonEditorOptions(schemaVersion: SchemaVersion) {
        this.editorOptions = new JsonEditorOptions();
        this.editorOptions.modes = ['tree', 'view', 'code', 'text'];

        // ✅ Enable necessary UI components
        this.editorOptions.mainMenuBar = true; // Enables the menu bar
        this.editorOptions.navigationBar = true; // Enables the navigation bar
        this.editorOptions.statusBar = true; // Enables the status bar
        if (schemaVersion.schemaVersionId) {
            // * return json options with validation not to edit the the schema
            this.editorOptions.onEditable = () => {
                return false;
            };
        } else {
            // * return json options with  allow to edit the the schema
            this.editorOptions.onEditable = () => {
                return true;
            };

            // * getting the json schema
            this.editorOptions.onChangeText = (event) => {
                this.updatedSchema = event;
                try {
                    const parsedSchema = JSON.parse(event);

                    if (!this.editor.isValidJson() || Object.keys(parsedSchema).length === 0) {
                        this.workflowStatusForm.setErrors({
                            inValidSchema: 'Schema is not valid',
                        });
                    } else {
                        this.workflowStatusForm.setErrors(null);
                    }
                } catch (error) {
                    this.workflowStatusForm.setErrors({
                        inValidSchema: 'Schema is not valid',
                    });
                }
            };
        }
        return this.editorOptions;
    }

    // * initialize required subscription
    initializeRequiredSubscription() {
        this.instanceDataService.currentInstanceName.pipe(takeUntil(this.destroy$)).subscribe((name) => {
            this.header_instanceName = name;
        });

        this.instanceDataService.currentAssetType.pipe(takeUntil(this.destroy$)).subscribe((assetTypeName) => {
            this.header_assetType = assetTypeName;
        });

        this.workflowStatusForm
            .get('name')
            .valueChanges.pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value) {
                    this.newWorkflowStatus.activityPackTypeStatus.name = value;
                }
            });
    }

    // * pagination handler
    getPaginationData(event: PageEvent) {
        this.schemaVersionList = this.fullSchemaVersionList
            .slice()
            .reverse()
            .slice(event.pageIndex * event.pageSize, event.pageIndex * event.pageSize + event.pageSize);
        return event;
    }

    // * save status changes
    saveWorkflowStatus() {
        if (this.modalMode == ModalTransaction.UPDATE) {
            if (this.isSchemaAdd) {
                this.iterateWorkflowObject(this.currentActivityPack.activityWorkFlow, true);
            } else {
                this.iterateWorkflowObject(this.currentActivityPack.activityWorkFlow, false);
            }
        } else if (this.modalMode == ModalTransaction.ADD) {
            this.createAddStatusPayload();
        }

        this.ngxUiLoaderService.start();
        this.managementApiService.updateActivityPackType(this.currentActivityPack.instanceId, [this.currentActivityPack]).subscribe(
            (res) => {
                this.ngxUiLoaderService.stop();
                if (res.success) {
                    // TODO toast message
                    this.customToastService.successToast('Workflow Status saved successfully!', 'Success');
                    this.ngbActiveModal.close(true);
                } else if (res.isCustom) {
                    this.customToastService.errorToast('Error while saving the workflow status!', 'Error');
                    // TODO error popup
                }
            },
            (err) => {
                this.ngxUiLoaderService.stop();
            }
        );
    }

    // * helper method to generate workflow order
    iterateWorkflowObject(activitypackWorkflow: ActivityWorkFlowHierarchy[], isSchemaAdded: boolean) {
        if (activitypackWorkflow.length > 0) {
            activitypackWorkflow.forEach((item) => {
                if (item.hasOwnProperty('next')) {
                    this.iterateWorkflowObject(item.next, isSchemaAdded);
                    if (item.activityWorkFlowId == this.workFlowStatus.activityWorkFlowId) {
                        if (isSchemaAdded) {
                            // * adding schema version to workflow status
                            let newSchemaVersion = new SchemaRevision();
                            this.updatedSchema = typeof this.updatedSchema == 'object' ? JSON.stringify(this.updatedSchema) : this.updatedSchema;
                            newSchemaVersion.schema = this.updatedSchema;
                            item.activityPackTypeStatus.schemaRevision = newSchemaVersion;
                            item.activityPackTypeStatus.name = this.workflowStatusForm.get('name').value;
                            item.activityPackTypeStatus.function = this.workflowStatusForm.get('functionVal').value;
                            item.activityPackTypeStatus.colour = this.workflowStatusForm.get('colour').value;
                        } else {
                            item.activityPackTypeStatus.name = this.workflowStatusForm.get('name').value;
                            item.activityPackTypeStatus.function = this.workflowStatusForm.get('functionVal').value;
                            item.activityPackTypeStatus.colour = this.workflowStatusForm.get('colour').value;
                        }
                    }
                } else {
                    if (item.activityWorkFlowId == this.workFlowStatus.activityWorkFlowId) {
                        if (isSchemaAdded) {
                            // * adding schema version to workflow status
                            let newSchemaVersion = new SchemaRevision();
                            this.updatedSchema = typeof this.updatedSchema == 'object' ? JSON.stringify(this.updatedSchema) : this.updatedSchema;
                            newSchemaVersion.schema = this.updatedSchema;
                            item.activityPackTypeStatus.schemaRevision = newSchemaVersion;
                            item.activityPackTypeStatus.name = this.workflowStatusForm.get('name').value;
                            item.activityPackTypeStatus.function = this.workflowStatusForm.get('functionVal').value;
                            item.activityPackTypeStatus.colour = this.workflowStatusForm.get('colour').value;
                        } else {
                            item.activityPackTypeStatus.name = this.workflowStatusForm.get('name').value;
                            item.activityPackTypeStatus.function = this.workflowStatusForm.get('functionVal').value;
                            item.activityPackTypeStatus.colour = this.workflowStatusForm.get('colour').value;
                        }
                    }
                }
            });
        }
    }

    // * helper method to create payload with newly added status
    createAddStatusPayload() {
        let workflowStatus = new ActivityPackTypeStatus();
        let workflowStatusType = new ActivityPackTypeStatusType();
        if (this.isSchemaAdd) {
            let schemaRevision = new SchemaRevision();
            this.updatedSchema = typeof this.updatedSchema == 'object' ? JSON.stringify(this.updatedSchema) : this.updatedSchema;
            schemaRevision.schema = this.updatedSchema;
            workflowStatus.schemaRevision = schemaRevision;
        }
        workflowStatus.name = this.workflowStatusForm.get('name').value;
        workflowStatus.function = this.workflowStatusForm.get('functionVal').value;
        workflowStatus.colour = this.workflowStatusForm.get('colour').value;
        this.newWorkflowStatus.activityPackTypeStatus = workflowStatus;
        this.currentWorkflowSteps.splice(this.indexOfStatus, 0, this.newWorkflowStatus);
        this.newWorkflowStatus.next = [];
        this.generateWorkflow();
        this.currentActivityPack.activityWorkFlow = this.payload;
    }

    // * initialize form
    initializeFormControl() {
        let namesList = this.currentWorkflowSteps.map((item) => item.activityPackTypeStatus.name);
        if (this.modalMode == ModalTransaction.UPDATE) {
            namesList = namesList.filter((item) => item !== this.workFlowStatus.activityPackTypeStatus.name);
        } else {
            namesList = this.currentWorkflowSteps.map((item) => item.activityPackTypeStatus.name);
        }
        this.workflowStatusForm = this.formBuilder.group({
            name: new UntypedFormControl(this.workFlowStatus?.activityPackTypeStatus.name ? this.workFlowStatus?.activityPackTypeStatus.name : '', [
                Validators.required,
                UniqueNameValidation(namesList),
            ]),
            functionVal: new UntypedFormControl(
                this.workFlowStatus?.activityPackTypeStatus.function ? this.workFlowStatus?.activityPackTypeStatus.function : ''
            ),
            colour: new UntypedFormControl(this.workFlowStatus?.activityPackTypeStatus.colour ? this.workFlowStatus?.activityPackTypeStatus.colour : '#ff0000'), // Default color (red)
        });
        this.initializeRequiredSubscription();
    }

    // * helper method to generte the activity workflow object
    generateWorkflow() {
        let zeroIndex = 0;
        this.currentWorkflowSteps.forEach((statusItem, pos) => {
            if (pos == 0) {
                this.payload.push(statusItem);
            }
            let temp: any;
            if (pos > 0) {
                for (let x = 0; x < pos; x++) {
                    if (x == 0) {
                        temp = this.payload[zeroIndex];
                    } else {
                        if (Object.prototype.toString.call(temp) == '[object Array]') {
                            temp = temp[zeroIndex].next;
                        } else {
                            temp = temp.next;
                        }
                    }
                }
            }
            if (pos !== 0) {
                if (Object.prototype.toString.call(temp) == '[object Array]') {
                    temp[zeroIndex].next.push(statusItem);
                } else {
                    temp.next.push(statusItem);
                }
            }
        });
    }

    checkDisable() {
        if (this.modalMode == ModalTransaction.ADD) {
            return !(this.workflowStatusForm.valid && this.workflowStatusForm.dirty && this.isSchemaValid());
        } else {
            return !(this.workflowStatusForm.valid && this.workflowStatusForm.dirty);
        }
    }
    isSchemaValid(): boolean {
        try {
            const parsedSchema = JSON.parse(this.updatedSchema);

            if ((!this.updatedSchema && !this.editor.isValidJson()) || Object.keys(parsedSchema).length === 0) {
                return false;
            } else {
                return true;
            }
        } catch (error) {
            return false;
        }
    }
    onKeyPress(event: KeyboardEvent) {
        this.customValidator.validateKeyPress(event);
    }

    ngOnDestroy() {
        this.destroy$.complete();
        this.destroy$.next(null);
    }
}
